import axios from 'axios';
import { store } from '../store';
import { logout } from '../store/reducers/userReducer';
import Cookies from 'js-cookie';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const STORAGE_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '/storage/');

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: add token to headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor: handle 401/403 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const currentPath = window.location.pathname;

    // Prevent auto redirect on login page itself
    if (error.response?.status === 401 && currentPath !== '/login') {
      store.dispatch(logout());

      Cookies.remove('token');

      window.location.href = '/login';
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
